var _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEventtime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_345_31842",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_345_31842)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.1637 17.4037L13.005 14.2499L12.476 15.8572C12.412 16.0357 12.2907 16.1228 12.1122 16.1185C11.9339 16.1142 11.8154 16.0228 11.7566 15.8443L10.2054 10.6778C10.1605 10.541 10.1938 10.4168 10.3054 10.3051C10.417 10.1936 10.5413 10.1603 10.6781 10.2051L15.8445 11.7564C16.023 11.8151 16.1144 11.9337 16.1187 12.112C16.123 12.2905 16.0359 12.4117 15.8575 12.4758L14.2502 13.0047L17.4168 16.1635C17.5942 16.3407 17.6829 16.5473 17.6829 16.7835C17.6829 17.0196 17.5942 17.2263 17.4168 17.4037C17.2395 17.581 17.0306 17.6697 16.7902 17.6697C16.5497 17.6697 16.3409 17.581 16.1637 17.4037ZM10.0002 3.33325C8.13905 3.33325 6.56266 3.97909 5.271 5.27075C3.97933 6.56242 3.3335 8.13881 3.3335 9.99992C3.3335 11.8034 3.93391 13.3355 5.13475 14.5962C6.33558 15.8569 7.82815 16.5385 9.61245 16.641C9.78968 16.658 9.94239 16.7328 10.0706 16.8653C10.1989 16.9978 10.2588 17.1528 10.2502 17.3301C10.2416 17.5073 10.1775 17.655 10.0579 17.773C9.93815 17.8911 9.78968 17.9459 9.61245 17.9374C8.55037 17.8946 7.56259 17.6505 6.64912 17.2049C5.73579 16.7595 4.93905 16.1757 4.25891 15.4535C3.57891 14.7312 3.04634 13.9005 2.6612 12.9614C2.27607 12.0224 2.0835 11.0352 2.0835 9.99992C2.0835 8.90589 2.29155 7.87735 2.70766 6.91429C3.12377 5.9511 3.68815 5.11318 4.40079 4.40054C5.11343 3.6879 5.95134 3.12353 6.91454 2.70742C7.87759 2.29131 8.90613 2.08325 10.0002 2.08325C12.0792 2.08325 13.897 2.8036 15.4537 4.24429C17.0102 5.68499 17.8382 7.47159 17.9377 9.60409C17.9547 9.77284 17.9034 9.91839 17.7837 10.0408C17.6641 10.1631 17.5156 10.2285 17.3383 10.237C17.1609 10.2456 17.0025 10.1866 16.8631 10.0599C16.7236 9.93339 16.6454 9.78145 16.6283 9.60409C16.5001 7.89464 15.8011 6.42214 14.5314 5.18659C13.2617 3.95103 11.7513 3.33325 10.0002 3.33325Z",
    fill: "#737373"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEventtime);
export default __webpack_public_path__ + "static/media/Event time.4e539163b3b01447503db7d89c879dfc.svg";
export { ForwardRef as ReactComponent };